import { createFileRoute } from '@tanstack/react-router'
import DemoPage from '@/pages/demo'
import { buildHead } from '@/shared/seo/seo-config'
import { redirectIfPublicPageHidden } from '@/shared/lib/hidden-public-pages'

export const Route = createFileRoute('/$lang/demo')({
  beforeLoad: ({ params }) => redirectIfPublicPageHidden('demo', params.lang),
  head: ({ params }) => buildHead('demo', params.lang),
  component: DemoPage,
  staticData: { layout: 'public' },
})
